






















































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import DirectoryMenuNavigationDrawer from '@/components/documents/DirectoryMenuNavigationDrawer.vue';

@Component({
  components: {
    DirectoryMenuNavigationDrawer,
  },
})
export default class DirectoryBase extends Vue {
  private parentDocumentGroup: string = 'アプリ開発';
  private documentTitle: string = 'ドキュメント';
  private moveEdit() {
    this.$router.push({ name: 'documents3' });
  }
  private selectDocument(parentDocument: string, selectedDocument: string) {
    this.parentDocumentGroup = parentDocument;
    this.documentTitle = selectedDocument;
  }
}
